$(document).ready(function () {

  if($('.banner-list .banner_box').length > 1){  
    $('.banner-list').slick({
      arrows: true,
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      adaptiveHeight: true
    });
  }

  $(".product-slider").slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1260,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 4
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      }
    ]
  });  
});

// Grawing zone functionality 

// $(document).ready(function () {
//   const STORAGE_KEY = "growing_zone_data";

//   function setButtonZoneText(data) {
//     $(".gz-selected").show();
//     $(".gz-zone-val").text(data.zone);
//   }

//   function showPopupResult(data) {
//     $(".popup-zone-text").text("Growing Zone " + data.zone);
//     $(".gz-form-view").hide();
//     $(".gz-result-view").show();
//   }

//   function showPopupForm() {
//     $(".gz-result-view").hide();
//     $(".gz-form-view").show();
//     $(".growing-zone-error").hide().text("");
//     $("#growingZoneZip").val("");
//   }

//   function openPopup() {
//     $(".growing-zone-header-popup").addClass("active");
//   }

//   function closePopup() {
//     $(".growing-zone-header-popup").removeClass("active");
//   }

//   function clearZone() {
//     localStorage.removeItem(STORAGE_KEY);
//     $(".gz-selected").hide();
//     $(".gz-zone-val").text("");

//     // Remove zone filter from URL without full page refresh
//     var url = new URL(window.location.href);
//     if (url.searchParams.has("filter.p.m.custom.grows_in_zones")) {
//       url.searchParams.delete("filter.p.m.custom.grows_in_zones");
      
//       // Use Shopify's facet system to re-render without full reload
//       var searchParams = url.searchParams.toString();
//       if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
//         FacetFiltersForm.renderPage(searchParams, null, true);
//       } else {
//         // Fallback: update URL without reload
//         history.pushState({searchParams: searchParams}, '', url.pathname + (searchParams ? '?' + searchParams : ''));
//         window.location.reload();
//       }

//       // Also uncheck the radio input
//       $('input[name="filter.p.m.custom.grows_in_zones"]:checked').prop('checked', false);
//     }

//     showPopupForm();
//     openPopup();
//   }

//   // Look up zone from growingZoneData by zip
//   function findZoneByZip(zip) {
//     var data = window.growingZoneData || [];
//     for (var i = 0; i < data.length; i++) {
//       if (String(data[i].zip) === String(zip)) {
//         return data[i].zone;
//       }
//     }
//     return null;
//   }

//   // Find the metaobject GID by matching zone against facet label text
//   function getGidForZone(zone) {
//     var zoneStr = String(zone).trim();
//     var gid = null;

//     document.querySelectorAll('input[name="filter.p.m.custom.grows_in_zones"]').forEach(function (input) {
//       if (gid) return;
//       var li = input.closest("li");
//       if (!li) return;
//       var labelEl = li.querySelector(".facet-checkbox__text-label");
//       if (!labelEl) return;

//       var labelText = labelEl.textContent.trim();

//       // Match: label could be "8", "Zone 8", "8a", etc.
//       // Try exact match first, then check if label contains the zone number
//       if (labelText === zoneStr || 
//           labelText === "Zone " + zoneStr ||
//           labelText.replace(/[^0-9]/g, '') === zoneStr.replace(/[^0-9]/g, '')) {
//         gid = input.value;
//       }
//     });

//     return gid;
//   }

//   function applyZoneFilter(zone) {
//     var zoneStr = String(zone);
//     var gid = getGidForZone(zoneStr);

//     if (!gid) return;

//     var url = new URL(window.location.href);
//     var currentVal = url.searchParams.get("filter.p.m.custom.grows_in_zones");

//     if (currentVal === gid) return;

//     url.searchParams.delete("filter.p.m.custom.grows_in_zones");
//     url.searchParams.set("filter.p.m.custom.grows_in_zones", gid);
//     window.location.replace(url.toString());
//   }

//   // On page load: restore from localStorage
//   var saved = localStorage.getItem(STORAGE_KEY);
//   if (saved) {
//     try {
//       var parsed = JSON.parse(saved);
//       setButtonZoneText(parsed);
//       showPopupResult(parsed);
//       applyZoneFilter(parsed.zone);
//     } catch (e) {
//       localStorage.removeItem(STORAGE_KEY);
//     }
//   }

//   // Toggle popup
//   $("body").on("click", ".growing-zone-button", function (e) {
//     e.preventDefault();
//     e.stopPropagation();
//     $(".growing-zone-header-popup").toggleClass("active");
//   });

//   $("body").on("click", ".growing-zone-header-popup", function (e) {
//     e.stopPropagation();
//   });

//   $(document).on("click", function () {
//     closePopup();
//   });

//   $("body").on("click", ".change-zone", function (e) {
//     e.preventDefault();
//     clearZone();
//   });

//   // Submit ZIP — lookup from window.growingZoneData
//   $("body").on("submit", "#growingZoneForm", function (e) {
//     e.preventDefault();

//     var zip = $("#growingZoneZip").val().trim();
//     $(".growing-zone-error").hide().text("");

//     if (!zip) {
//       $(".growing-zone-error").show().text("Please enter ZIP code.");
//       return;
//     }

//     if (!/^\d{5}$/.test(zip)) {
//       $(".growing-zone-error").show().text("Please enter a valid 5-digit ZIP.");
//       return;
//     }

//     var zone = findZoneByZip(zip);

//     if (!zone) {
//       $(".growing-zone-error").show().text("Zone not found for this ZIP code.");
//       return;
//     }

//     var result = { zip: zip, zone: zone };
//     localStorage.setItem(STORAGE_KEY, JSON.stringify(result));

//     setButtonZoneText(result);
//     showPopupResult(result);
//     closePopup();

//     applyZoneFilter(result.zone);
//   });

//   // Listen for manual filter clicks on "Grows in Zones" radio buttons
//   $("body").on("change", 'input[name="filter.p.m.custom.grows_in_zones"]', function () {
//     var $input = $(this);
//     var li = $input.closest("li");
//     var labelEl = li.find(".facet-checkbox__text-label");
//     var zone = labelEl.length ? labelEl.text().trim() : null;

//     if (!zone) return;

//     // Find a zip code from growingZoneData that matches this zone
//     var zip = "";
//     var zoneData = window.growingZoneData || [];
//     for (var i = 0; i < zoneData.length; i++) {
//       if (String(zoneData[i].zone) === String(zone)) {
//         zip = String(zoneData[i].zip);
//         break;
//       }
//     }

//     var data = { zip: zip, zone: zone };
//     localStorage.setItem(STORAGE_KEY, JSON.stringify(data));

//     setButtonZoneText(data);
//     showPopupResult(data);
//   });
// });

$(document).ready(function () {
  const STORAGE_KEY = "growing_zone_data";

  function setButtonZoneText(data) {
    $(".gz-selected").show();
    $(".gz-zone-val").text(data.zone);
  }

  function showPopupResult(data) {
    $(".popup-zone-text").text("Growing Zone " + data.zone);
    $(".gz-form-view").hide();
    $(".gz-result-view").show();
  }

  function showPopupForm() {
    $(".gz-result-view").hide();
    $(".gz-form-view").show();
    $(".growing-zone-error").hide().text("");
    $("#growingZoneZip").val("");
  }

  function openPopup() {
    $(".growing-zone-header-popup").addClass("active");
  }

  function closePopup() {
    $(".growing-zone-header-popup").removeClass("active");
  }

  function clearZone() {
    localStorage.removeItem(STORAGE_KEY);
    $(".gz-selected").hide();
    $(".gz-zone-val").text("");

    var url = new URL(window.location.href);
    if (url.searchParams.has("filter.p.m.custom.grows_in_zones")) {
      url.searchParams.delete("filter.p.m.custom.grows_in_zones");

      var searchParams = url.searchParams.toString();
      if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
        FacetFiltersForm.renderPage(searchParams, null, true);
      } else {
        history.pushState({ searchParams: searchParams }, '', url.pathname + (searchParams ? '?' + searchParams : ''));
        window.location.reload();
      }

      $('input[name="filter.p.m.custom.grows_in_zones"]:checked').prop('checked', false);
    }

    showPopupForm();
    openPopup();
  }

  // Look up zone from growingZoneData by zip
  function findZoneByZip(zip) {
    var data = window.growingZoneData || [];
    for (var i = 0; i < data.length; i++) {
      if (String(data[i].zip) === String(zip)) {
        return data[i].zone;
      }
    }
    return null;
  }

  // Find a zip from growingZoneData that matches a zone
  function findZipByZone(zone) {
    var data = window.growingZoneData || [];
    for (var i = 0; i < data.length; i++) {
      if (String(data[i].zone) === String(zone)) {
        return String(data[i].zip);
      }
    }
    return "";
  }

  // Find the metaobject GID by matching zone against facet label text
  function getGidForZone(zone) {
    var zoneStr = String(zone).trim();
    var gid = null;

    document.querySelectorAll('input[name="filter.p.m.custom.grows_in_zones"]').forEach(function (input) {
      if (gid) return;
      var li = input.closest("li");
      if (!li) return;
      var labelEl = li.querySelector(".facet-checkbox__text-label");
      if (!labelEl) return;

      var labelText = labelEl.textContent.trim();
      if (labelText === zoneStr ||
        labelText === "Zone " + zoneStr ||
        labelText.replace(/[^0-9]/g, '') === zoneStr.replace(/[^0-9]/g, '')) {
        gid = input.value;
      }
    });

    return gid;
  }

  // function applyZoneFilter(zone) {
  //   var zoneStr = String(zone);
  //   var gid = getGidForZone(zoneStr);

  //   if (!gid) return;

  //   var url = new URL(window.location.href);
  //   var currentVal = url.searchParams.get("filter.p.m.custom.grows_in_zones");

  //   if (currentVal === gid) return;

  //   url.searchParams.delete("filter.p.m.custom.grows_in_zones");
  //   url.searchParams.set("filter.p.m.custom.grows_in_zones", gid);
  //   window.location.replace(url.toString());
  // }
  function applyZoneFilter(zone) {
    var zoneStr = String(zone);
    var gid = getGidForZone(zoneStr);

    if (!gid) return;

    var url = new URL(window.location.href);
    var currentVal = url.searchParams.get("filter.p.m.custom.grows_in_zones");

    // Already applied
    if (currentVal === gid) return;

    url.searchParams.delete("filter.p.m.custom.grows_in_zones");
    url.searchParams.set("filter.p.m.custom.grows_in_zones", gid);

    var searchParams = url.searchParams.toString();

    // Use Shopify's AJAX facet system instead of page reload
    if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
      FacetFiltersForm.renderPage(searchParams, null, true);

      // Also check the correct radio input in the DOM
      document.querySelectorAll('input[name="filter.p.m.custom.grows_in_zones"]').forEach(function (input) {
        input.checked = (input.value === gid);
      });
    } else {
      // Fallback for non-collection pages
      window.location.replace(url.toString());
    }
  }

  // On page load: restore from localStorage
  var saved = localStorage.getItem(STORAGE_KEY);
  if (saved) {
    try {
      var parsed = JSON.parse(saved);
      setButtonZoneText(parsed);
      showPopupResult(parsed);
      applyZoneFilter(parsed.zone);
    } catch (e) {
      localStorage.removeItem(STORAGE_KEY);
    }
  }

  // Sync zone from URL: if URL has filter param, update header/popup/localStorage
  (function syncZoneFromURL() {
    var url = new URL(window.location.href);
    var gid = url.searchParams.get("filter.p.m.custom.grows_in_zones");
    if (!gid) return;

    var zone = null;
    document.querySelectorAll('input[name="filter.p.m.custom.grows_in_zones"]').forEach(function (input) {
      if (zone) return;
      if (input.value === gid) {
        var li = input.closest("li");
        var labelEl = li ? li.querySelector(".facet-checkbox__text-label") : null;
        if (labelEl) {
          zone = labelEl.textContent.trim();
        }
      }
    });

    if (!zone) return;

    var savedData = localStorage.getItem(STORAGE_KEY);
    var data = {};
    if (savedData) {
      try { data = JSON.parse(savedData); } catch (e) {}
    }

    if (String(data.zone) !== String(zone)) {
      var zip = findZipByZone(zone);
      data = { zip: zip, zone: zone };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    }

    setButtonZoneText(data);
    showPopupResult(data);
  })();

  // Toggle popup
  $("body").on("click", ".growing-zone-button", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(".growing-zone-header-popup").toggleClass("active");
  });

  $("body").on("click", ".growing-zone-header-popup", function (e) {
    e.stopPropagation();
  });

  $(document).on("click", function () {
    closePopup();
  });

  $("body").on("click", ".change-zone", function (e) {
    e.preventDefault();
    clearZone();
  });

  // Listen for manual filter clicks on "Grows in Zones" radio buttons
  $("body").on("change", 'input[name="filter.p.m.custom.grows_in_zones"]', function () {
    var $input = $(this);
    var li = $input.closest("li");
    var labelEl = li.find(".facet-checkbox__text-label");
    var zone = labelEl.length ? labelEl.text().trim() : null;

    if (!zone) return;

    var zip = findZipByZone(zone);
    var data = { zip: zip, zone: zone };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));

    setButtonZoneText(data);
    showPopupResult(data);
  });

  // Submit ZIP — lookup from window.growingZoneData
  $("body").on("submit", "#growingZoneForm", function (e) {
    e.preventDefault();

    var zip = $("#growingZoneZip").val().trim();
    $(".growing-zone-error").hide().text("");

    if (!zip) {
      $(".growing-zone-error").show().text("Please enter ZIP code.");
      return;
    }

    if (!/^\d{5}$/.test(zip)) {
      $(".growing-zone-error").show().text("Please enter a valid 5-digit ZIP.");
      return;
    }

    var zone = findZoneByZip(zip);

    if (!zone) {
      $(".growing-zone-error").show().text("Zone not found for this ZIP code.");
      return;
    }

    var result = { zip: zip, zone: zone };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(result));

    setButtonZoneText(result);
    showPopupResult(result);
    closePopup();

    applyZoneFilter(result.zone);
  });
  
});